export default "__VITE_PUBLIC_ASSET__4d81a4a2__"